import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { LOCAL_STORAGE_KEYS } from "../../constants/localstorageConstants";

/**
 * Creates an instance of axios for supply chain
 */
class ApiInstance {
  readonly client: AxiosInstance;

  constructor(config?: AxiosRequestConfig) {
    this.client = axios.create(config);
    const storedToken = localStorage.getItem(
      LOCAL_STORAGE_KEYS.SUPPLY_CHAIN_TOKEN,
    );
    if (!storedToken) {
      return;
    }
    try {
      const parsedToken = JSON.parse(storedToken);
      if (!parsedToken) {
        return;
      }
      const authHeader = `Bearer ${parsedToken}`;
      this.client.defaults.headers.Authorization = authHeader;
    } catch (e) {
      delete this.client.defaults.headers.Authorization;
    }
  }

  updateToken = (token?: string) => {
    if (token) {
      this.client.defaults.headers.Authorization = `Bearer ${token}`;
    } else {
      delete this.client.defaults.headers.Authorization;
    }
    return token;
  };
}

const SUPPLY_CHAIN_APP_URL = "https://app.sb.supplychainmusic.com/";
const SUPPLY_CHAIN_FILE_URL = "https://file.sb.supplychainmusic.com/";

/**
 * Ensures that a single instance of axios is created for supply chain
 */
export const SupplyChainAppAxios = new ApiInstance({
  baseURL: SUPPLY_CHAIN_APP_URL,
});
export const SupplyChainFileAxios = new ApiInstance({
  baseURL: SUPPLY_CHAIN_FILE_URL,
});
